const HEADER_SCRIPT_ATTRIBUTE = "data-biyo-order-header-script";

function markManagedNode(node) {
  if (node && node.nodeType === Node.ELEMENT_NODE) {
    node.setAttribute(HEADER_SCRIPT_ATTRIBUTE, "true");
  }
}

export function removeOrderLiveHeaderScript() {
  document
    .querySelectorAll(`[${HEADER_SCRIPT_ATTRIBUTE}]`)
    .forEach((node) => node.parentNode?.removeChild(node));
}

function createExecutableScriptNode(sourceNode) {
  const script = document.createElement("script");

  Array.from(sourceNode.attributes || []).forEach((attribute) => {
    script.setAttribute(attribute.name, attribute.value);
  });

  script.text = sourceNode.textContent || "";
  markManagedNode(script);
  return script;
}

export function applyOrderLiveHeaderScript(rawScript) {
  removeOrderLiveHeaderScript();

  const headerScript = String(rawScript || "").trim();
  if (!headerScript) return;

  const template = document.createElement("template");
  template.innerHTML = headerScript;

  const nodes = Array.from(template.content.childNodes).filter((node) => {
    return node.nodeType === Node.ELEMENT_NODE;
  });

  if (nodes.length === 0) {
    const script = document.createElement("script");
    script.text = headerScript;
    markManagedNode(script);
    document.head.appendChild(script);
    return;
  }

  nodes.forEach((node) => {
    const nodeName = node.nodeName.toLowerCase();
    const managedNode =
      nodeName === "script"
        ? createExecutableScriptNode(node)
        : node.cloneNode(true);

    markManagedNode(managedNode);
    document.head.appendChild(managedNode);
  });
}
